import { EDIT_MODE } from './edit-mode.js';
import { BRAIN_TYPE } from './brains.js';
import { isWebApp } from './platform.js';

export default async (filename, blob, brainType, editMode, saveAs = false) => {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    let extension = '';
    if (brainType == BRAIN_TYPE.EDU) {
        extension = 'abot';
    } else if (brainType == BRAIN_TYPE.WEB_VR) {
        extension = 'vr';
    } else {
        if (brainType == BRAIN_TYPE.ENTRY) {
            extension = 'bbot';
        }
        if (brainType == BRAIN_TYPE.EDU_AND_ENTRY) {
            extension = 'cbot';
        }
    }

    // Use special ms version if available to get it working on Edge.
    if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename + "." + extension);
        return;
    }

    if ('download' in HTMLAnchorElement.prototype) {
        console.log('Standard download method saveAs:', saveAs);
        if (isWebApp() && saveAs) {
            try {
                // 彈出另存新檔對話框
                const fileHandle = await window.showSaveFilePicker({
                    suggestedName: `${filename}.${extension}`,
                    types: [
                        {
                            description: extension.toUpperCase() + " file",
                            accept: {
                                [blob.type || "application/octet-stream"]: [`.${extension}`],
                            },
                        },
                    ],
                });

                // 建立寫入器並寫入 Blob
                const writable = await fileHandle.createWritable();
                await writable.write(blob);
                await writable.close();

                console.log("✅ 檔案已成功另存新檔");
            } catch (err) {
                if (err.name !== "AbortError") {
                    console.error("❌ 儲存檔案失敗：", err);
                } else {
                    console.log("⚠️ 使用者取消另存新檔");
                }
            }
        } else {
            console.log('Standard download method');
            const url = window.URL.createObjectURL(blob);
            downloadLink.href = url;
            downloadLink.download = filename + "." + extension;
            downloadLink.type = blob.type;
            downloadLink.click();
            document.body.removeChild(downloadLink);
            window.URL.revokeObjectURL(url);
        }

    } else {
        console.log('iOS Safari download method');
        // iOS Safari, open a new page and set href to data-uri
        let popup = window.open('', '_blank');
        const reader = new FileReader();
        reader.onloadend = function () {
            popup.location.href = reader.result;
            popup = null;
        };
        reader.readAsDataURL(blob);
    }
};
